module.exports = __webpack_public_path__ + "img/consultor-avatar2.74c31309.jpg";